export const getters = {
  productMasterList: (state) => state.productMasterList,
  createProductMasterSuccess: (state) => state.createProductMasterSuccess,
  deleteProductMasterSuccess: (state) => state.deleteProductMasterSuccess,
  updateProductMasterSuccess: (state) => state.updateProductMasterSuccess,
  propagateProductMasterSuccess: (state) => state.propagateProductMasterSuccess,
  productSearchList: (state) => state.productSearchList,
  productSearchProgress: (state) => state.productSearchProgress
};
